import React from "react";
import { THEME_SETTINGS } from "@theme-settings";
import CountryIcon from "./CountryIcon";
import JerseyIcon from "./JerseyIcon";

type Props = {
	showCountryFlag: boolean | undefined;
	className?: string;
	flagCode?: string;
	jerseyTypeAbrv?: string;
	opponentFlagCode?: string;
	opponentJerseyType?: string;
};

export default function TeamIconBB(props: Props) {
	if (!THEME_SETTINGS.features.isTeamIconEnabled) return null;

	const {
		showCountryFlag,
		flagCode,
		className,
		jerseyTypeAbrv,
		opponentJerseyType,
		opponentFlagCode,
	} = props;

	if (!showCountryFlag) {
		return (
			<JerseyIcon
				jerseyTypeAbrv={jerseyTypeAbrv}
				opponentJerseyType={opponentJerseyType}
				className={className}
			/>
		);
	}

	if (showCountryFlag) {
		return (
			<CountryIcon
				flagCode={flagCode}
				opponentFlagCode={opponentFlagCode}
				className={className}
			/>
		);
	}

	return null;
}
